module.exports = __webpack_public_path__ + "212d666e0f0e3379249cfc03a024a662.svg";